import { createFileRoute } from "@tanstack/react-router";
import { SearchPage } from "@/features/search/SearchPage";
import { searchFormSchema, type SearchForm } from "@/features/search/model";
export const Route = createFileRoute("/_authenticated/_protected/search")({
  validateSearch: (input: Record<string, unknown>): Partial<SearchForm> => {
    return searchFormSchema.partial().parse({ ...input, ...(typeof input.types === "string" ? { types: input.types.split(",") } : {}) });
  },
  component: Page,
});
function Page() {
  const initial = Route.useSearch();
  const navigate = Route.useNavigate();
  return <SearchPage key={JSON.stringify(initial)} initial={initial} onSearch={form => void navigate({ search: form })} />;
}
